import { AccordionStandard } from "../../../../modules/accordion/components/AccordionStandard/AccordionStandard";
import type { IAccordionBlockProps } from "./AccordionBlock.props";

export const AccordionBlock = (props: IAccordionBlockProps) => {
  if (!props.items?.length) {
    return null;
  }

  return <AccordionStandard {...props} />;
};

AccordionBlock.displayName = "Block::AccordionBlock";
